type $CSSProperties = {
  [key: string]: React.CSSProperties;
};

export class lib_styleSheets {
  static create<Styles extends $CSSProperties>(styles: Styles): Styles {
    return styles;
  }
}
